module.exports = __webpack_public_path__ + "static/img/kathi-mit-katze.f3eafb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/kathi-mit-katze.jpg
// module id = tcC5
// module chunks = 0